define('lib/plugin/PluginBroker',['require','marionette'],function (require) {	

	var Marionette = require('marionette');
	
	var PluginBroker = Marionette.Object.extend({
		
		_plugins: [],
		_pluginsMap: {},
		
		addPlugin: function (pluginName, plugin) {
			this._plugins.push(plugin);
			this._pluginsMap[pluginName] = plugin;
		},

		getPlugin: function (pluginName) {
			if (this._pluginsMap[pluginName]) {
				return this._pluginsMap[pluginName];
			}
		},

		modifySteps: function (steps) {
			_.each(this._plugins, function (plugin) {
				var res = plugin.modifySteps(steps);
				if (res) {
					steps = res;
				}
			});
			
			return steps;
		},
		
		getStep: function (step, params) {
			var result = null;
			for (var i = 0; i < this._plugins.length; i++) {
				var plugin = this._plugins[i];
				var res = plugin.getStep(step, params);
				if (res) {
					return res;
				}
			}			
		},

        validate: function () {
            var res = true;
            _.each(this._plugins, function (plugin) {
                res = plugin.validate() && res;
            });
            return res;
        },

		getValidationErrors: function() {
			var res = [];
			_.each(this._plugins, function (plugin) {
				var error = plugin.getValidationError();
				if (error) {
					res.push(error);
				}
			});
			return res;
		},

		setStepManager: function (manager) {
			this.perform('setStepManager', [manager]);
		},

		initModules: function (layout) {
			this.perform('initModules', [layout]);
		},

		perform: function (method, args) {
			this.triggerMethod('perform:event', method, args);
			_.each(this._plugins, function (plugin) {
				if (_.isFunction(plugin[method])) {
					plugin[method].apply(plugin, args);
				}
			});
		}
		
	});
	
	PluginBroker._instance = null;
	
	PluginBroker.getInstance = function () {
		if (!PluginBroker._instance) {
			PluginBroker._instance = new PluginBroker();
		}
		return PluginBroker._instance;
	};
	
	return PluginBroker;
	
});
